<ng-container *ngFor="let section of content?.sections">
    <section [class.bg-white]="section?.color == 'WHITE'" [class.bg-grey]="section?.color == 'GREY'"
        [class.bg-off-white]="section?.color == 'OFF-WHITE'"
        [class.bg-grey-gradient]="section?.color == 'GREY-GRADIENT'"
        [class.bg-blue-pattern]="section?.color == 'BLUE-PATTERN'">

        <!-- 1 Column Sections -->

        <ng-container *ngIf="section?.columns == 1">
            <ng-container *ngFor="let module of section?.modules">
                <app-pb-header-home *ngIf="module?.module?.identifier == 'header-home'" [content]="module?.items"
                    [module]="module"></app-pb-header-home>

                <div *ngIf="module.module.identifier != 'header-home'"
                    [class.container-fluid]="module?.width == 'FULL'"
                    [class.px-0]="module?.width == 'FULL'"
                    [class.container]="module?.width == 'CONSTRAINED'"
                    [class.noticeboard-header-container]="module?.module?.identifier == 'header-notice-board'"
                    [class.secondary-header-container]="module?.module?.identifier == 'header-general'"
                    [class.secondary-footer-container]="module?.module?.identifier == 'footer-secondary'"
                    [style.padding-top.px]="module?.padding_top" [style.padding-bottom.px]="module?.padding_bottom"
                    [style.margin-top.px]="module?.margin_top" [style.margin-bottom.px]="module?.margin_bottom"
                    [class.d-none]="module?.show == 'DESKTOP'"
                    [class.d-sm-none]="module?.show == 'DESKTOP'"
                    [class.d-md-block]="module?.show == 'DESKTOP'"
                    [class.d-md-none]="module?.show == 'MOBILE'"
                    [class.d-lg-none]="module?.show == 'MOBILE'"
                    [class.d-xl-none]="module?.show == 'MOBILE'"
                    [class.reset-margin-mobile]="module?.margin_top < 0 || module?.margin_bottom < 0">
                    <div class="row"
                        [class.no-gutters]="module?.width == 'FULL'">
                        <div class="col-12"
                            [class.px-0]="module?.width == 'FULL'">
                            <app-pb-header-general *ngIf="module.module.identifier == 'header-general'"
                                [content]="module?.items" [module]="module"></app-pb-header-general>

                            <app-pb-header-notice-board *ngIf="module.module.identifier == 'header-notice-board'"
                                [content]="module?.items" [module]="module"></app-pb-header-notice-board>

                            <app-pb-exam-counter *ngIf="module.module.identifier == 'exam-counter'"
                                [content]="module?.items" [module]="module"></app-pb-exam-counter>

                            <app-pb-divider-text-left *ngIf="module.module.identifier == 'divider-line-text-left'"
                                [content]="module?.items" [module]="module"></app-pb-divider-text-left>

                            <app-pb-divider-text-center *ngIf="module.module.identifier == 'divider-line-text-center'"
                                [content]="module?.items" [module]="module"></app-pb-divider-text-center>

                            <app-pb-divider-text-right *ngIf="module.module.identifier == 'divider-line-text-right'"
                                [content]="module?.items" [module]="module"></app-pb-divider-text-right>

                            <app-pb-divider-text-none *ngIf="module.module.identifier == 'divider-line-text-none'"
                                [content]="module?.items" [module]="module"></app-pb-divider-text-none>

                            <app-pb-wysiwyg *ngIf="module.module.identifier == 'media'" [content]="module?.items"
                                [module]="module" [section]="section"></app-pb-wysiwyg>

                            <app-pb-reading-resources-summary
                                *ngIf="module.module.prebuilt_component_identifier == 'app-reading-resources-swiper'"
                                [module]="module"></app-pb-reading-resources-summary>

                            <app-pb-testimonials
                                *ngIf="module.module.prebuilt_component_identifier == 'app-swiper-quote'"
                                [module]="module" [content]="module?.items"></app-pb-testimonials>

                            <app-pb-institute-listing *ngIf="module.module.identifier == 'institute-listing'"
                                [module]="module"></app-pb-institute-listing>

                            <app-pb-team-member *ngIf="module.module.identifier == 'team-member'"
                                [content]="module?.items" [module]="module"></app-pb-team-member>

                            <app-pb-map *ngIf="module.module.identifier == 'maps'" [content]="module?.items"
                                [module]="module"></app-pb-map>

                            <app-pb-gallery *ngIf="module.module.identifier == 'image-gallery'"
                                [content]="module?.items" [module]="module"></app-pb-gallery>

                            <app-pb-promotion-single *ngIf="module.module.identifier == 'promotion-single'"
                                [content]="module?.items" [module]="module"></app-pb-promotion-single>

                            <app-pb-contact-form *ngIf="module.module.identifier == 'form-contact'"
                                [content]="module?.items" [module]="module"></app-pb-contact-form>

                            <app-pb-tutor-support-form *ngIf="module.module.identifier == 'form-tutor-support'"
                                [content]="module?.items" [module]="module"></app-pb-tutor-support-form>

                            <app-pb-value-add-form *ngIf="module.module.identifier == 'form-value-add'"
                                [content]="module?.items" [module]="module"></app-pb-value-add-form>

                            <app-pb-event-application-form *ngIf="module.module.identifier == 'form-event-application'"
                                [content]="module?.items" [module]="module" [id]="module?.prebuilt_module_data?.EventTypeKey"></app-pb-event-application-form>

                            <app-pb-lead-gen-form *ngIf="module.module.identifier == 'form-lead-gen'"
                                [content]="module?.items" [module]="module" [section]="section"></app-pb-lead-gen-form>

                            <app-pb-institute-level-breakdown
                                *ngIf="module.module.identifier == 'institute-level-breakdown'"
                                [id]="module?.prebuilt_module_data?.CourseKey" [module]="module">
                            </app-pb-institute-level-breakdown>

                            <app-pb-institute-header *ngIf="module.module.identifier == 'institute-header'"
                                [id]="module?.prebuilt_module_data?.CourseKey" [module]="module"></app-pb-institute-header>

                            <app-pb-institute-price-comparison
                                *ngIf="module.module.identifier == 'institute-price-comparison'"
                                [id]="module?.prebuilt_module_data?.CourseKey" [module]="module">
                            </app-pb-institute-price-comparison>

                            <app-pb-faqs *ngIf="module.module.identifier == 'faq'" [content]="module?.items"
                                [module]="module"></app-pb-faqs>

                            <app-pb-study-options *ngIf="module.module.identifier == 'study-options'" [module]="module">
                            </app-pb-study-options>

                            <app-pb-content-cards *ngIf="module.module.identifier == 'content-cards'" [module]="module">
                            </app-pb-content-cards>

                            <app-pb-progress *ngIf="module.module.identifier == 'progress'" [module]="module">
                            </app-pb-progress>

                            <app-pb-event *ngIf="module.module.identifier == 'event'" [content]="module?.items"
                                [module]="module"></app-pb-event>

                            <app-pb-link-arrow-left *ngIf="module.module.identifier == 'link-arrow-left'"
                                [content]="module?.items" [module]="module"></app-pb-link-arrow-left>

                            <app-pb-link-arrow-right *ngIf="module.module.identifier == 'link-arrow-right'"
                                [content]="module?.items" [module]="module"></app-pb-link-arrow-right>

                            <app-pb-link-arrow-none *ngIf="module.module.identifier == 'link-arrow-none'"
                                [content]="module?.items" [module]="module"></app-pb-link-arrow-none>

                            <app-pb-footer-secondary *ngIf="module.module.identifier == 'footer-secondary'"
                                [content]="module?.items" [module]="module"></app-pb-footer-secondary>

                            <app-pb-promotions-slider *ngIf="module.module.identifier == 'promotion-slider'"
                                [content]="module?.items" [module]="module"></app-pb-promotions-slider>

                            <app-pb-progress-custom *ngIf="module.module.identifier == 'progress-custom'"
                                [content]="module?.items" [module]="module"></app-pb-progress-custom>

                            <app-pb-code *ngIf="module.module.identifier == 'code'" [content]="module?.items"
                                [module]="module"></app-pb-code>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <!-- 2 Column Sections -->

        <ng-container *ngIf="section?.columns == 2">
            <div class="container">
                <div class="row">
                    <ng-container *ngFor='let col of [].constructor(section?.columns); let i = index'>
                        <div class="col-12 col-sm-6">
                            <ng-container *ngFor="let module of section?.modules">
                                <div [style.padding-top.px]="(module.column == (i+1) ? module?.padding_top : 0)"
                                    [style.padding-bottom.px]="(module.column == (i+1) ? module?.padding_bottom : 0)"
                                    [style.margin-bottom.px]="(module.column == (i+1) ? module?.margin_bottom : 0)"
                                    [style.margin-top.px]="(module.column == (i+1) ? module?.margin_top : 0)"
                                    [class.reset-margin-mobile]="module?.margin_top < 0 || module?.margin_bottom < 0"
                                    [class.d-none]="module?.show == 'DESKTOP'"
                                    [class.d-sm-none]="module?.show == 'DESKTOP'"
                                    [class.d-md-block]="module?.show == 'DESKTOP'"
                                    [class.d-md-none]="module?.show == 'MOBILE'"
                                    [class.d-lg-none]="module?.show == 'MOBILE'"
                                    [class.d-xl-none]="module?.show == 'MOBILE'">
                                    <app-pb-header-general
                                        *ngIf="module.module.identifier == 'header-general' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-header-general>

                                    <app-pb-header-notice-board
                                        *ngIf="module.module.identifier == 'header-notice-board' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-header-notice-board>

                                    <app-pb-header-home
                                        *ngIf="module.module.identifier == 'header-home' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-header-home>

                                    <app-pb-exam-counter
                                        *ngIf="module.module.identifier == 'exam-counter' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-exam-counter>

                                    <app-pb-divider-text-left
                                        *ngIf="module.module.identifier == 'divider-line-text-left' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-divider-text-left>

                                    <app-pb-divider-text-center
                                        *ngIf="module.module.identifier == 'divider-line-text-center' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-divider-text-center>

                                    <app-pb-divider-text-right
                                        *ngIf="module.module.identifier == 'divider-line-text-right' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-divider-text-right>

                                    <app-pb-divider-text-none
                                        *ngIf="module.module.identifier == 'divider-line-text-none' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-divider-text-none>

                                    <app-pb-wysiwyg
                                        *ngIf="module.module.identifier == 'media' && module.column && module.column == (i+1)"
                                        [content]="module?.items" [module]="module" [section]="section">
                                    </app-pb-wysiwyg>

                                    <app-pb-reading-resources-summary
                                        *ngIf="module.module.prebuilt_component_identifier == 'app-reading-resources-swiper' && module.column == (i+1)"
                                        [module]="module"></app-pb-reading-resources-summary>

                                    <app-pb-testimonials
                                        *ngIf="module.module.prebuilt_component_identifier == 'app-swiper-quote' && module.column == (i+1)"
                                        [module]="module" [content]="module?.items"></app-pb-testimonials>

                                    <app-pb-institute-listing
                                        *ngIf="module.module.identifier == 'institute-listing' && module.column == (i+1)"
                                        [module]="module"></app-pb-institute-listing>

                                    <app-pb-team-member
                                        *ngIf="module.module.identifier == 'team-member' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-team-member>

                                    <app-pb-map *ngIf="module.module.identifier == 'maps' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-map>

                                    <app-pb-gallery
                                        *ngIf="module.module.identifier == 'image-gallery' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-gallery>

                                    <app-pb-promotion-single
                                        *ngIf="module.module.identifier == 'promotion-single' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-promotion-single>

                                    <app-pb-contact-form
                                        *ngIf="module.module.identifier == 'form-contact' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-contact-form>

                                    <app-pb-tutor-support-form
                                        *ngIf="module.module.identifier == 'form-tutor-support' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-tutor-support-form>

                                    <app-pb-value-add-form
                                        *ngIf="module.module.identifier == 'form-value-add' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-value-add-form>

                                    <app-pb-event-application-form
                                        *ngIf="module.module.identifier == 'form-event-application' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module" [id]="module?.prebuilt_module_data?.EventTypeKey"></app-pb-event-application-form>

                                    <app-pb-lead-gen-form
                                        *ngIf="module.module.identifier == 'form-lead-gen' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module" [section]="section">
                                    </app-pb-lead-gen-form>

                                    <app-pb-institute-level-breakdown
                                        *ngIf="module.module.identifier == 'institute-level-breakdown' && module.column == (i+1)"
                                        [id]="module?.prebuilt_module_data?.CourseKey" [module]="module">
                                    </app-pb-institute-level-breakdown>

                                    <app-pb-institute-header
                                        *ngIf="module.module.identifier == 'institute-header' && module.column == (i+1)"
                                        [id]="module?.prebuilt_module_data?.CourseKey" [module]="module"></app-pb-institute-header>

                                    <app-pb-institute-price-comparison
                                        *ngIf="module.module.identifier == 'institute-price-comparison' && module.column == (i+1)"
                                        [id]="module?.prebuilt_module_data?.CourseKey" [module]="module">
                                    </app-pb-institute-price-comparison>

                                    <app-pb-faqs *ngIf="module.module.identifier == 'faq' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-faqs>

                                    <app-pb-study-options
                                        *ngIf="module.module.identifier == 'study-options' && module.column == (i+1)"
                                        [module]="module"></app-pb-study-options>

                                    <app-pb-content-cards
                                        *ngIf="module.module.identifier == 'content-cards' && module.column == (i+1)"
                                        [module]="module"></app-pb-content-cards>

                                    <app-pb-progress
                                        *ngIf="module.module.identifier == 'progress' && module.column == (i+1)"
                                        [module]="module"></app-pb-progress>

                                    <app-pb-event *ngIf="module.module.identifier == 'event' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-event>

                                    <app-pb-link-arrow-left
                                        *ngIf="module.module.identifier == 'link-arrow-left' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-link-arrow-left>

                                    <app-pb-link-arrow-right
                                        *ngIf="module.module.identifier == 'link-arrow-right' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-link-arrow-right>

                                    <app-pb-link-arrow-none
                                        *ngIf="module.module.identifier == 'link-arrow-none' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-link-arrow-none>

                                    <app-pb-footer-secondary
                                        *ngIf="module.module.identifier == 'footer-secondary' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-footer-secondary>

                                    <app-pb-promotions-slider
                                        *ngIf="module.module.identifier == 'promotion-slider' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-promotions-slider>

                                    <app-pb-progress-custom
                                        *ngIf="module.module.identifier == 'progress-custom' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-progress-custom>

                                    <app-pb-code *ngIf="module.module.identifier == 'code' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-code>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>

        <!-- 3 Column Sections -->

        <ng-container *ngIf="section?.columns == 3">
            <div class="container">
                <div class="row">
                    <ng-container *ngFor='let col of [].constructor(section?.columns); let i = index'>
                        <div class="col-12 col-sm-6 col-md-4">
                            <ng-container *ngFor="let module of section?.modules">
                                <div [style.padding-top.px]="(module.column == (i+1) ? module?.padding_top : 0)"
                                    [style.padding-bottom.px]="(module.column == (i+1) ? module?.padding_bottom : 0)"
                                    [style.margin-bottom.px]="(module.column == (i+1) ? module?.margin_bottom : 0)"
                                    [style.margin-top.px]="(module.column == (i+1) ? module?.margin_top : 0)"
                                    [class.reset-margin-mobile]="module?.margin_top < 0 || module?.margin_bottom < 0"
                                    [class.d-none]="module?.show == 'DESKTOP'"
                                    [class.d-sm-none]="module?.show == 'DESKTOP'"
                                    [class.d-md-block]="module?.show == 'DESKTOP'"
                                    [class.d-md-none]="module?.show == 'MOBILE'"
                                    [class.d-lg-none]="module?.show == 'MOBILE'"
                                    [class.d-xl-none]="module?.show == 'MOBILE'">
                                    <app-pb-header-general
                                        *ngIf="module.module.identifier == 'header-general' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-header-general>

                                    <app-pb-header-notice-board
                                        *ngIf="module.module.identifier == 'header-notice-board' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-header-notice-board>

                                    <app-pb-header-home
                                        *ngIf="module.module.identifier == 'header-home' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-header-home>

                                    <app-pb-exam-counter
                                        *ngIf="module.module.identifier == 'exam-counter' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-exam-counter>

                                    <app-pb-divider-text-left
                                        *ngIf="module.module.identifier == 'divider-line-text-left' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-divider-text-left>

                                    <app-pb-divider-text-center
                                        *ngIf="module.module.identifier == 'divider-line-text-center' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-divider-text-center>

                                    <app-pb-divider-text-right
                                        *ngIf="module.module.identifier == 'divider-line-text-right' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-divider-text-right>

                                    <app-pb-divider-text-none
                                        *ngIf="module.module.identifier == 'divider-line-text-none' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-divider-text-none>

                                    <app-pb-wysiwyg
                                        *ngIf="module.module.identifier == 'media' && module.column && module.column == (i+1)"
                                        [content]="module?.items" [module]="module" [section]="section">
                                    </app-pb-wysiwyg>

                                    <app-pb-reading-resources-summary
                                        *ngIf="module.module.prebuilt_component_identifier == 'app-reading-resources-swiper' && module.column == (i+1)"
                                        [module]="module"></app-pb-reading-resources-summary>

                                    <app-pb-testimonials
                                        *ngIf="module.module.prebuilt_component_identifier == 'app-swiper-quote' && module.column == (i+1)"
                                        [module]="module" [content]="module?.items"></app-pb-testimonials>

                                    <app-pb-institute-listing
                                        *ngIf="module.module.identifier == 'institute-listing' && module.column == (i+1)"
                                        [module]="module"></app-pb-institute-listing>

                                    <app-pb-team-member
                                        *ngIf="module.module.identifier == 'team-member' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-team-member>

                                    <app-pb-map *ngIf="module.module.identifier == 'maps' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-map>

                                    <app-pb-gallery
                                        *ngIf="module.module.identifier == 'image-gallery' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-gallery>

                                    <app-pb-promotion-single
                                        *ngIf="module.module.identifier == 'promotion-single' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-promotion-single>

                                    <app-pb-contact-form
                                        *ngIf="module.module.identifier == 'form-contact' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-contact-form>

                                    <app-pb-tutor-support-form
                                        *ngIf="module.module.identifier == 'form-tutor-support' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-tutor-support-form>

                                    <app-pb-value-add-form
                                        *ngIf="module.module.identifier == 'form-value-add' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-value-add-form>

                                    <app-pb-event-application-form
                                        *ngIf="module.module.identifier == 'form-event-application' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module" [id]="module?.prebuilt_module_data?.EventTypeKey"></app-pb-event-application-form>

                                    <app-pb-lead-gen-form
                                        *ngIf="module.module.identifier == 'form-lead-gen' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module" [section]="section">
                                    </app-pb-lead-gen-form>

                                    <app-pb-institute-level-breakdown
                                        *ngIf="module.module.identifier == 'institute-level-breakdown' && module.column == (i+1)"
                                        [id]="module?.prebuilt_module_data?.CourseKey" [module]="module">
                                    </app-pb-institute-level-breakdown>

                                    <app-pb-institute-header
                                        *ngIf="module.module.identifier == 'institute-header' && module.column == (i+1)"
                                        [id]="module?.prebuilt_module_data?.CourseKey" [module]="module"></app-pb-institute-header>

                                    <app-pb-institute-price-comparison
                                        *ngIf="module.module.identifier == 'institute-price-comparison' && module.column == (i+1)"
                                        [id]="module?.prebuilt_module_data?.CourseKey" [module]="module">
                                    </app-pb-institute-price-comparison>

                                    <app-pb-faqs *ngIf="module.module.identifier == 'faq' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-faqs>

                                    <app-pb-study-options
                                        *ngIf="module.module.identifier == 'study-options' && module.column == (i+1)"
                                        [module]="module"></app-pb-study-options>

                                    <app-pb-content-cards
                                        *ngIf="module.module.identifier == 'content-cards' && module.column == (i+1)"
                                        [module]="module"></app-pb-content-cards>

                                    <app-pb-progress
                                        *ngIf="module.module.identifier == 'progress' && module.column == (i+1)"
                                        [module]="module"></app-pb-progress>

                                    <app-pb-event *ngIf="module.module.identifier == 'event' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-event>

                                    <app-pb-link-arrow-left
                                        *ngIf="module.module.identifier == 'link-arrow-left' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-link-arrow-left>

                                    <app-pb-link-arrow-right
                                        *ngIf="module.module.identifier == 'link-arrow-right' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-link-arrow-right>

                                    <app-pb-link-arrow-none
                                        *ngIf="module.module.identifier == 'link-arrow-none' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-link-arrow-none>

                                    <app-pb-footer-secondary
                                        *ngIf="module.module.identifier == 'footer-secondary' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-footer-secondary>

                                    <app-pb-promotions-slider
                                        *ngIf="module.module.identifier == 'promotion-slider' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-promotions-slider>

                                    <app-pb-progress-custom
                                        *ngIf="module.module.identifier == 'progress-custom' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-progress-custom>

                                    <app-pb-code *ngIf="module.module.identifier == 'code' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-code>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>

        <!-- 4 Column Sections -->

        <ng-container *ngIf="section?.columns == 4">
            <div class="container">
                <div class="row">
                    <ng-container *ngFor='let col of [].constructor(section?.columns); let i = index'>
                        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                            <ng-container *ngFor="let module of section?.modules">
                                <div [style.padding-top.px]="(module.column == (i+1) ? module?.padding_top : 0)"
                                    [style.padding-bottom.px]="(module.column == (i+1) ? module?.padding_bottom : 0)"
                                    [style.margin-bottom.px]="(module.column == (i+1) ? module?.margin_bottom : 0)"
                                    [style.margin-top.px]="(module.column == (i+1) ? module?.margin_top : 0)"
                                    [class.reset-margin-mobile]="module?.margin_top < 0 || module?.margin_bottom < 0"
                                    [class.d-none]="module?.show == 'DESKTOP'"
                                    [class.d-sm-none]="module?.show == 'DESKTOP'"
                                    [class.d-md-block]="module?.show == 'DESKTOP'"
                                    [class.d-md-none]="module?.show == 'MOBILE'"
                                    [class.d-lg-none]="module?.show == 'MOBILE'"
                                    [class.d-xl-none]="module?.show == 'MOBILE'">
                                    <app-pb-header-general
                                        *ngIf="module.module.identifier == 'header-general' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-header-general>

                                    <app-pb-header-notice-board
                                        *ngIf="module.module.identifier == 'header-notice-board' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-header-notice-board>

                                    <app-pb-header-home
                                        *ngIf="module.module.identifier == 'header-home' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-header-home>

                                    <app-pb-exam-counter
                                        *ngIf="module.module.identifier == 'exam-counter' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-exam-counter>

                                    <app-pb-divider-text-left
                                        *ngIf="module.module.identifier == 'divider-line-text-left' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-divider-text-left>

                                    <app-pb-divider-text-center
                                        *ngIf="module.module.identifier == 'divider-line-text-center' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-divider-text-center>

                                    <app-pb-divider-text-right
                                        *ngIf="module.module.identifier == 'divider-line-text-right' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-divider-text-right>

                                    <app-pb-divider-text-none
                                        *ngIf="module.module.identifier == 'divider-line-text-none' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-divider-text-none>

                                    <app-pb-wysiwyg
                                        *ngIf="module.module.identifier == 'media' && module.column && module.column == (i+1)"
                                        [content]="module?.items" [module]="module" [section]="section">
                                    </app-pb-wysiwyg>

                                    <app-pb-reading-resources-summary
                                        *ngIf="module.module.prebuilt_component_identifier == 'app-reading-resources-swiper' && module.column == (i+1)"
                                        [module]="module"></app-pb-reading-resources-summary>

                                    <app-pb-testimonials
                                        *ngIf="module.module.prebuilt_component_identifier == 'app-swiper-quote' && module.column == (i+1)"
                                        [module]="module" [content]="module?.items"></app-pb-testimonials>

                                    <app-pb-institute-listing
                                        *ngIf="module.module.identifier == 'institute-listing' && module.column == (i+1)"
                                        [module]="module"></app-pb-institute-listing>

                                    <app-pb-team-member
                                        *ngIf="module.module.identifier == 'team-member' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-team-member>

                                    <app-pb-map *ngIf="module.module.identifier == 'maps' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-map>

                                    <app-pb-gallery
                                        *ngIf="module.module.identifier == 'image-gallery' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-gallery>

                                    <app-pb-promotion-single
                                        *ngIf="module.module.identifier == 'promotion-single' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-promotion-single>

                                    <app-pb-contact-form
                                        *ngIf="module.module.identifier == 'form-contact' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-contact-form>

                                    <app-pb-tutor-support-form
                                        *ngIf="module.module.identifier == 'form-tutor-support' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-tutor-support-form>

                                    <app-pb-value-add-form
                                        *ngIf="module.module.identifier == 'form-value-add' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-value-add-form>

                                    <app-pb-event-application-form
                                        *ngIf="module.module.identifier == 'form-event-application' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module" [id]="module?.prebuilt_module_data?.EventTypeKey"></app-pb-event-application-form>

                                    <app-pb-lead-gen-form
                                        *ngIf="module.module.identifier == 'form-lead-gen' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module" [section]="section">
                                    </app-pb-lead-gen-form>

                                    <app-pb-institute-level-breakdown
                                        *ngIf="module.module.identifier == 'institute-level-breakdown' && module.column == (i+1)"
                                        [id]="module?.prebuilt_module_data?.CourseKey" [module]="module">
                                    </app-pb-institute-level-breakdown>

                                    <app-pb-institute-header
                                        *ngIf="module.module.identifier == 'institute-header' && module.column == (i+1)"
                                        [id]="module?.prebuilt_module_data?.CourseKey" [module]="module"></app-pb-institute-header>

                                    <app-pb-institute-price-comparison
                                        *ngIf="module.module.identifier == 'institute-price-comparison' && module.column == (i+1)"
                                        [id]="module?.prebuilt_module_data?.CourseKey" [module]="module">
                                    </app-pb-institute-price-comparison>

                                    <app-pb-faqs *ngIf="module.module.identifier == 'faq' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-faqs>

                                    <app-pb-study-options
                                        *ngIf="module.module.identifier == 'study-options' && module.column == (i+1)"
                                        [module]="module"></app-pb-study-options>

                                    <app-pb-content-cards
                                        *ngIf="module.module.identifier == 'content-cards' && module.column == (i+1)"
                                        [module]="module"></app-pb-content-cards>

                                    <app-pb-progress
                                        *ngIf="module.module.identifier == 'progress' && module.column == (i+1)"
                                        [module]="module"></app-pb-progress>

                                    <app-pb-event *ngIf="module.module.identifier == 'event' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-event>

                                    <app-pb-link-arrow-left
                                        *ngIf="module.module.identifier == 'link-arrow-left' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-link-arrow-left>

                                    <app-pb-link-arrow-right
                                        *ngIf="module.module.identifier == 'link-arrow-right' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-link-arrow-right>

                                    <app-pb-link-arrow-none
                                        *ngIf="module.module.identifier == 'link-arrow-none' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-link-arrow-none>

                                    <app-pb-footer-secondary
                                        *ngIf="module.module.identifier == 'footer-secondary' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-footer-secondary>

                                    <app-pb-promotions-slider
                                        *ngIf="module.module.identifier == 'promotion-slider' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-promotions-slider>

                                    <app-pb-progress-custom
                                        *ngIf="module.module.identifier == 'progress-custom' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-progress-custom>

                                    <app-pb-code *ngIf="module.module.identifier == 'code' && module.column == (i+1)"
                                        [content]="module?.items" [module]="module"></app-pb-code>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    </section>
</ng-container>